export const CONTACT_INFO = {
  PHONE: {
    DISPLAY: '+91 790755 5371',
    VALUE: '+917907555371'
  },
  WHATSAPP: {
    MESSAGE: 'Hello! I want to book a newspaper ad.'
  },
  EMAIL: 'bookmynewsad@gmail.com',
  SUPPORT_EMAIL: 'venu.omshreeads@gmail.com',
  ADDRESS: {
    LINE1: 'OM Shree Ads, Rajarajeshwari Nagar, Off. Gopalan Arcade Mall',
    LINE2: 'Mysore Road, Bangalore - 560039',
    CITY: 'Bangalore, India'
  },
  SOCIAL: {
    FACEBOOK: 'https://facebook.com',
    INSTAGRAM: 'https://instagram.com',
    TWITTER: 'https://twitter.com',
    LINKEDIN: 'https://linkedin.com'
  }
};

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'YOUR_SERVICE_ID', // Replace with your EmailJS Service ID
  TEMPLATE_ID: 'YOUR_TEMPLATE_ID', // Replace with your EmailJS Template ID
  PUBLIC_KEY: 'YOUR_PUBLIC_KEY' // Replace with your EmailJS Public Key
};
